module.exports = __webpack_public_path__ + "img/daishenhe.ab5ebf13.jpg";